import {Component, Input} from '@angular/core';
import {localizeUserExamGrade, UserExamGrade, UserExamGradeStats} from '../../../model/stats/Stats';

@Component({
  selector: 'grade-results-table',
  templateUrl: './grade-results-table.component.html',
  styleUrls: ['./grade-results-table.component.scss']
})
export class GradeResultsTableComponent {

  readonly examGrades = UserExamGrade;

  columnsToDisplay = ['excellent', 'good', 'average'];

  @Input() stats?: UserExamGradeStats[];

  constructor() {
  }

  localizeExamGrade(grade: UserExamGrade) {
    return localizeUserExamGrade(grade);
  }

}
